import ExcelJS from 'exceljs'

export interface TemplateColumn {
  readonly header: string
  readonly key: string
  readonly example: string
}

export const TEMPLATE_COLUMNS: ReadonlyArray<TemplateColumn> = [
  { header: 'Email', key: 'identifier', example: 'jane.doe@example.com' },
  { header: 'Display Name', key: 'displayName', example: 'Jane Doe' },
  { header: 'Role', key: 'role', example: 'Engineer' },
  { header: 'Department', key: 'department', example: 'Engineering' },
  { header: 'Clearance', key: 'clearance', example: 'Secret' },
]

export function generateSubjectTemplateCsv(): string {
  const headers = TEMPLATE_COLUMNS.map((c) => c.header).join(',')
  const example = TEMPLATE_COLUMNS.map((c) => c.example).join(',')
  return `${headers}\n${example}\n`
}

export function generateSubjectTemplateXlsx(): ExcelJS.Workbook {
  const workbook = new ExcelJS.Workbook()
  const sheet = workbook.addWorksheet('Subjects')

  const headerRow = sheet.addRow(TEMPLATE_COLUMNS.map((c) => c.header))
  headerRow.eachCell((cell) => {
    cell.font = { bold: true }
  })

  sheet.addRow(TEMPLATE_COLUMNS.map((c) => c.example))

  TEMPLATE_COLUMNS.forEach((_, i) => {
    const col = sheet.getColumn(i + 1)
    col.width = 20
  })

  return workbook
}

export async function downloadSubjectTemplate(format: 'xlsx' | 'csv'): Promise<void> {
  const filename = `subject-upload-template.${format}`

  let blob: Blob
  if (format === 'csv') {
    const csv = generateSubjectTemplateCsv()
    blob = new Blob([csv], { type: 'text/csv' })
  } else {
    const workbook = generateSubjectTemplateXlsx()
    const buffer = await workbook.xlsx.writeBuffer()
    blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
  }

  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}
